"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./set_records"), exports);
__exportStar(require("./add_fields"), exports);
__exportStar(require("./set_field_attr"), exports);
__exportStar(require("./paste_set_fields"), exports);
__exportStar(require("./paste_set_records"), exports);
__exportStar(require("./add_records"), exports);
__exportStar(require("./move_views"), exports);
__exportStar(require("./modify_view"), exports);
__exportStar(require("./delete_views"), exports);
__exportStar(require("./add_views"), exports);
__exportStar(require("./move_row"), exports);
__exportStar(require("./delete_record"), exports);
__exportStar(require("./move_column"), exports);
__exportStar(require("./delete_field"), exports);
__exportStar(require("./set_sort_info"), exports);
__exportStar(require("./set_row_height"), exports);
__exportStar(require("./set_auto_head_height"), exports);
__exportStar(require("./set_columns_property"), exports);
__exportStar(require("./set_view_filter"), exports);
__exportStar(require("./set_group"), exports);
__exportStar(require("./set_gallery_style"), exports);
__exportStar(require("./fill_data_to_cells"), exports);
__exportStar(require("./set_kanban_style"), exports);
__exportStar(require("./set_gantt_style"), exports);
__exportStar(require("./set_calendar_style"), exports);
__exportStar(require("./set_org_chart_style"), exports);
__exportStar(require("./insert_comment"), exports);
__exportStar(require("./update_comment"), exports);
__exportStar(require("./delete_comment"), exports);
__exportStar(require("../../commands/common/add_widget_panel"), exports);
__exportStar(require("./move_widget_panel"), exports);
__exportStar(require("./delete_widget_panel"), exports);
__exportStar(require("../../commands/common/add_widget_to_panel"), exports);
__exportStar(require("../../commands/common/delete_widget"), exports);
__exportStar(require("./change_widget_in_panel_height"), exports);
__exportStar(require("./move_widget"), exports);
__exportStar(require("./rollback"), exports);
__exportStar(require("../../commands/datasheet/set_view_lock_info"), exports);
__exportStar(require("./fix_one_way_link_dstId"), exports);
__exportStar(require("./set_view_frozen_column_count"), exports);
__exportStar(require("./set_date_time_cell_alarm"), exports);
//# sourceMappingURL=index.js.map